(() => {
  const style = new URL(location.href).searchParams.get('cart_style');
  const names = { jade: 'A · 暖橘', porcelain: 'B · 暖瓷橘', ink: 'C · 曜石黑' };
  document.documentElement.dataset.cartStyle = Object.hasOwn(names, style) ? style : 'orange';
  if (!Object.hasOwn(names, style)) return;
  document.title = `${names[style]}｜購物車預覽`;
  const showPreview = async () => {
    await customElements.whenDefined('cart-drawer');
    const cart = document.getElementById('cart-drawer');
    if (cart) {
      cart.open();
    }
  };
  if (document.readyState === 'complete') showPreview();
  else window.addEventListener('load', showPreview, { once: true });
})();
